import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { selectValueDisplay, DISPLAY_OPTIONS } from './value-display-flip-button-slice';
import { NumericFormat } from 'react-number-format';

interface ValueDisplayFlipCardProps {
  moneyValue: number
  percentageValue: number
  className: string
}

/**
 * A card that flips and alternates displayed portfolio values between MONEY (R$) and PERCENTAGE (%).
 */
const ValueDisplayFlipCard: React.FC<ValueDisplayFlipCardProps> = (props: ValueDisplayFlipCardProps) => {

  const valueDisplay = useAppSelector(selectValueDisplay);

  return (
    <div className="group w-full" data-side={valueDisplay.displayOption === DISPLAY_OPTIONS.PERCENTAGE ? 'front' : 'back'}>
      <div className='flex items-center group-data-[side=back]:[transform:rotateY(180deg)] [transform-style:preserve-3d] transition-transform ease-in-out duration-500'>
        <div className="absolute w-full text-center backface-hidden rotate-0 [transform:rotateY(180deg)]">
          <label className={props.className}>
            {props.moneyValue.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </label>
        </div>
        <div className="absolute w-full text-center backface-hidden rotate-0">
          <label className={props.className}>
            {props.percentageValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
          </label>
        </div>
      </div >
    </div>
  );
}

export default ValueDisplayFlipCard;